<template>
  <Modal v-model="isVisible" title="运营图片临时图床" :mask-closable="false" class="temp-image-bed-modal">
    <div class="temp-image-bed-content">
      <!-- 头部提示 -->
      <div class="temp-image-bed-header">
        <div class="header-left">
          <span class="header-icon">
            <Icon type="md-images" />
          </span>
          <div class="header-info">
            <div class="header-title">运营图片临时图床</div>
            <div class="header-tip">上传后，图片链接将在 <span class="highlight">15 天</span>后自动失效</div>
          </div>
        </div>
        <div class="header-right">
          <div>支持格式:</div>
          <div>JPG, PNG, WEBP, PDF, ZIP</div>
        </div>
      </div>

      <!-- 上传区域 -->
      <div class="upload-area-wrap">
        <Upload
          ref="uploadRef"
          multiple
          type="drag"
          action=""
          :before-upload="beforeUpload"
          :format="['jpg', 'jpeg', 'png', 'webp', 'pdf', 'zip']"
          :accept="'.jpg,.jpeg,.png,.webp,.pdf,.zip'"
          :show-upload-list="false"
        >
          <div class="upload-drag-area">
            <Icon type="ios-cloud-upload" size="52" style="color: #2d8cf0" />
            <p class="upload-main-text">
              拖拽
              <span class="highlight-link">图片</span>
              或
              <span class="highlight-link">PDF、ZIP压缩包</span>
              到这里，或者点击浏览
            </p>
            <p class="upload-sub-text">支持批量选择多张图片直接上传，也支持传ZIP包自动解压生成</p>
          </div>
        </Upload>
      </div>

      <!-- Tabs 区域 -->
      <div class="table-area">
        <div class="table-tabs-wrap">
          <Tabs v-model="activeTab" @on-click="handleTabChange">
            <TabPane :label="`本次上传 (${currentPagination.total})`" name="current"></TabPane>
            <TabPane :label="`历史上传 (${historyTotal})`" name="history"></TabPane>
          </Tabs>
          <div class="table-actions">
            <Button type="primary" icon="md-copy" @click="batchCopyCurrentPage">批量复制当前页图片链接</Button>
            <Button
              type="success"
              icon="md-download"
              class="ml10"
              @click="exportImageLinks('check')"
              :disabled="exportLoading"
            >导出选中图片链接</Button>
            <Button
              type="success"
              icon="md-download"
              class="ml10"
              @click="exportImageLinks('all')"
              :disabled="exportLoading"
            >导出所有图片链接</Button>
          </div>
        </div>
        <Table
          :loading="tableLoading"
          border
          :height="330"
          :columns="tableColumns"
          :data="tableData"
          @on-selection-change="handleSelectionChange"
        />
        <div class="table-page-wrap">
          <Page
            :total="activePagination.total"
            :current="activePagination.pageNum"
            :page-size="activePagination.pageSize"
            :page-size-opts="[50, 100, 200]"
            show-total
            show-elevator
            show-sizer
            @on-change="handlePageChange"
            @on-page-size-change="handlePageSizeChange"
          />
        </div>
      </div>
    </div>
    <div slot="footer">
      <Button @click="isVisible = false">关 闭</Button>
    </div>
    <Spin v-if="pageLoading" fix></Spin>
  </Modal>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'TempImageBedModal',
  props: {
    modalVisible: { type: Boolean, default: false }
  },
  data () {
    return {
      isVisible: false,
      pageLoading: false,
      exportLoading: false,
      tableLoading: false,
      activeTab: 'current',
      currentUploadIds: [], // 本次上传的图片ID列表
      currentUploadList: [], // 本次上传列表
      currentSelected: [], // 本次上传选中项
      historyList: [], // 历史列表数据
      historySelected: [], // 历史上传选中项
      historyTotal: 0,
      uploadingCount: 0, // 正在上传的文件计数
      pendingFiles: [], // 待上传文件队列
      uploadTimer: null, // 批量上传定时器
      currentPagination: {
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      historyPagination: {
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '预览',
          key: 'preview',
          width: 80,
          align: 'center',
          render: (h, params) => {
            const url = params.row.fileUrl;
            const originalName = params.row.originalFileName || '';
            const isPdf = originalName.slice(originalName.lastIndexOf('.') + 1).toLowerCase() === 'pdf';
            if (!url) return h('span', '-');
            if (isPdf) {
              return h('span', {
                style: 'font-size: 12px; color: #ed4014;'
              }, 'PDF');
            }
            return h('Poptip', {
              props: {
                transfer: true,
                trigger: 'hover',
                placement: 'right'
              }
            }, [
              h('img', {
                attrs: {
                  src: url,
                  style: 'width: 40px; height: 40px; object-fit: cover; cursor: pointer; border-radius: 4px;'
                }
              }),
              h('div', {
                slot: 'content'
              }, [
                h('img', {
                  attrs: {
                    src: url,
                    style: 'max-width: 300px; max-height: 300px;'
                  }
                })
              ])
            ]);
          }
        },
        {
          title: '原文件名',
          key: 'originalFileName',
          minWidth: 180,
          tooltip: true
        },
        {
          title: '上传日期',
          key: 'createdTime',
          width: 160,
          align: 'center'
        },
        {
          title: '临时 URL (15有效)',
          key: 'fileUrl',
          minWidth: 280,
          render: (h, params) => {
            const url = params.row.fileUrl;
            const originalName = params.row.originalFileName || '';
            const isPdf = originalName.slice(originalName.lastIndexOf('.') + 1).toLowerCase() === 'pdf';
            const expireText = this.getExpireText(params.row.expireTime);
            return h('div', {
              style: 'display: flex; align-items: center; gap: 8px;'
            }, [
              h('span', {
                style: 'flex: 100;color: #2d8cf0; cursor: pointer; word-break: break-all;',
                on: {
                  click: () => {
                    if (isPdf) {
                      fetch(url).then(res => res.blob()).then(blob => {
                        this.$common.blobToBase64(blob).then(data => {
                          const fileBold = this.$common.base64ToBlob(data, 'application/pdf');
                          this.$common.previewFile(fileBold);
                        });
                      }).catch((err) => {
                        console.error(err);
                        window.open(url, '_blank');
                      });
                    } else {
                      window.open(url, '_blank');
                    }
                  }
                }
              }, url),
              h('Tag', {
                props: {
                  color: expireText.includes('剩余') ? 'orange' : 'default'
                }
              }, expireText)
            ]);
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                icon: 'md-copy'
              },
              on: {
                click: () => {
                  this.copyText(params.row.fileUrl);
                }
              }
            }, '复制');
          }
        }
      ]
    };
  },
  computed: {
    tableData () {
      return this.activeTab === 'current' ? this.currentUploadList : this.historyList;
    },
    activePagination () {
      return this.activeTab === 'current' ? this.currentPagination : this.historyPagination;
    }
  },
  watch: {
    modalVisible: {
      immediate: true,
      handler (val) {
        this.isVisible = val;
        if (val) {
          this.initData();
        } else {
          this.resetData();
        }
      }
    },
    isVisible: {
      handler (val) {
        this.$emit('update:modalVisible', val);
      }
    }
  },
  methods: {
    initData () {
      this.activeTab = 'history';
      this.historyPagination.pageNum = 1;
      this.historyPagination.pageSize = 50;
      this.fetchList();
    },
    resetData () {
      this.currentUploadList = [];
      this.historyList = [];
      this.currentUploadIds = [];
      this.currentPagination.total = 0;
      this.currentPagination.pageNum = 1;
      this.historyPagination.total = 0;
      this.historyPagination.pageNum = 1;
      this.historyTotal = 0;
    },
    // 上传前校验并收集文件，批量上传
    beforeUpload (file) {
      const ext = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
      const allowExts = ['jpg', 'jpeg', 'png', 'webp', 'zip', 'pdf'];
      if (!allowExts.includes(ext)) {
        this.$Message.error(`文件 ${file.name} 格式不支持，仅支持 JPG、PNG、WEBP、PDF、ZIP`);
        return false;
      }
      this.pendingFiles.push(file);
      if (this.uploadTimer) clearTimeout(this.uploadTimer);
      this.uploadTimer = setTimeout(() => {
        const files = this.pendingFiles.splice(0);
        if (files.length === 0) return;
        this.batchUploadFiles(files);
      }, 50);
      return false;
    },
    // 批量上传文件，全部完成后再查询列表
    batchUploadFiles (files) {
      this.pageLoading = true;
      const uploadTasks = files.map(f => {
        const fExt = f.name.slice(f.name.lastIndexOf('.') + 1).toLowerCase();
        return () => this.doUpload(f, fExt === 'zip');
      });
      this.$common.allSettled(uploadTasks, { limit: 5 }).then((results) => {
        let totalUploadedIds = [];
        let totalSuccess = 0;
        let totalFail = 0;
        results.forEach(item => {
          if (item.status === 'fulfilled' && item.value) {
            totalUploadedIds = [...totalUploadedIds, ...(item.value.uploadedIds || [])];
            totalSuccess += (item.value.successCount || 0);
            totalFail += (item.value.failCount || 0);
          } else {
            totalFail += 1;
          }
        });
        if (totalUploadedIds.length > 0) {
          this.currentUploadIds = [...new Set([...this.currentUploadIds, ...totalUploadedIds])];
        }
        if (totalFail > 0) {
          this.$Message.warning(`上传完成，成功 ${totalSuccess} 个，失败 ${totalFail} 个`);
        } else {
          this.$Message.success(`上传成功 ${totalSuccess} 个`);
        }
        // 切换到本次上传标签并刷新数据
        this.activeTab = 'current';
        this.currentPagination.pageNum = 1;
        this.fetchCurrentUploadList();
      }).finally(() => {
        this.pageLoading = false;
      });
    },
    // 执行单个上传，返回 Promise
    doUpload (file, isZip) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        const sgin = (Number((Math.random() * Math.pow(10, 10)).toFixed(0))).toString(32);
        formData.append('file', file);
        const url = `${isZip ? api.uploadTempZip : api.uploadTempImage}?time=${sgin}`;
        this.axios.post(url, formData).then((res) => {
          if (!res || !res.data || res.data.code !== 0) {
            this.$Message.error(res && res.data && res.data.message ? res.data.message : '上传失败');
            resolve(null);
            return;
          }
          resolve(res.data.datas || {});
        }).catch((err) => {
          reject(err);
        });
      });
    },
    // Tab 切换
    handleTabChange () {
      this.activePagination.pageNum = 1;
      this.fetchList();
    },
    // 获取列表
    fetchList () {
      if (this.activeTab === 'current') {
        this.fetchCurrentUploadList();
      } else {
        this.fetchHistoryList();
      }
    },
    // 查询本次上传列表（不依赖当前 activeTab）
    fetchCurrentUploadList () {
      if (this.currentUploadIds.length === 0) {
        this.currentUploadList = [];
        this.currentPagination.total = 0;
        return;
      }
      this.tableLoading = true;
      const params = {
        pageNum: this.currentPagination.pageNum,
        pageSize: this.currentPagination.pageSize,
        currentUploadIds: this.currentUploadIds
      };
      this.axios.post(api.tempImageHostList, params).then((res) => {
        if (!res || !res.data || res.data.code !== 0) {
          this.tableLoading = false;
          return;
        }
        const data = res.data.datas || {};
        this.currentUploadList = data.list || [];
        this.currentPagination.total = data.total || 0;
      }).catch(() => {
        this.currentUploadList = [];
        this.currentPagination.total = 0;
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    // 查询历史列表
    fetchHistoryList () {
      this.tableLoading = true;
      const params = {
        pageNum: this.historyPagination.pageNum,
        pageSize: this.historyPagination.pageSize
      };
      this.axios.post(api.tempImageHostList, params).then((res) => {
        if (!res || !res.data || res.data.code !== 0) {
          this.tableLoading = false;
          return;
        }
        const data = res.data.datas || {};
        this.historyList = data.list || [];
        this.historyTotal = data.total || 0;
        this.historyPagination.total = data.total || 0;
      }).catch(() => {
        this.historyList = [];
        this.historyPagination.total = 0;
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    // 分页
    handlePageChange (page) {
      this.activePagination.pageNum = page;
      this.fetchList();
    },
    handlePageSizeChange (size) {
      this.activePagination.pageSize = size;
      this.activePagination.pageNum = 1;
      this.fetchList();
    },
    // 复制文本
    copyText (text) {
      if (!text) return;
      this.$common.copyToClip(text).then(() => {
        this.$Message.success('复制成功');
      }).catch(() => {
        this.$Message.error('复制失败');
      });
    },
    // 选中项变化
    handleSelectionChange (selection) {
      if (this.activeTab === 'current') {
        this.currentSelected = selection;
      } else {
        this.historySelected = selection;
      }
    },
    // 批量复制当前页
    batchCopyCurrentPage () {
      const list = this.tableData;
      if (!list || list.length === 0) {
        return this.$Message.warning('当前页暂无数据');
      }
      const urls = list.map(item => item.fileUrl).join('\n');
      this.copyText(urls);
    },
    // 导出图片链接
    exportImageLinks (type) {
      if (type === 'check' || (this.activeTab === 'current' && type === 'all')) {
        let exportIds = [];
        if ((this.activeTab === 'current')) {
          if (type === 'all') {
            exportIds = this.currentUploadIds;
          } else {
            exportIds = this.currentSelected.map(item => item.id);
          }
          if (this.currentUploadIds.length === 0) {
            this.$Message.error('导出失败，本次未上传数据');
            return;
          }
        } else if (this.activeTab === 'history') {
          exportIds = this.historySelected.map(item => item.id);
        }
        if (type === 'check' && exportIds.length === 0) {
          this.$Message.error('导出失败，请先选择需要导出的数据');
          return;
        }
        this.exportLoading = true;
        this.axios({
          method: "post",
          url: api.exportSelectTempImageUrls,
          data: {
            currentUploadIds: exportIds,
          },
          responseType: "blob",
          timeout: 1000 * 60 * 10, // 10 分钟
        }).then((res) => {
          if (!res || !res.resData) {
            this.$Message.error('导出失败');
            return;
          }
          const blob = new Blob([res.resData]);
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = res.filename || `临时图床图片链接_${this.$common.getDateTime(new Date(), 'YYYY-MM-DD_HH-mm-ss')}.xlsx`;
          link.click();
          URL.revokeObjectURL(link.href);
          this.$Message.success('导出成功');
        }).catch((err) => {
          console.error(err);
        }).finally(() => {
          this.exportLoading = false;
        });
        return;
      }
      this.exportLoading = true;
      this.axios.get(api.exportTempImageUrls, { responseType: 'blob' }).then((res) => {
        if (!res || !res.resData) {
          this.$Message.error('导出失败');
          return;
        }
        const blob = new Blob([res.resData]);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = res.filename || `临时图床图片链接_${this.$common.getDateTime(new Date(), 'YYYY-MM-DD_HH-mm-ss')}.xlsx`;
        link.click();
        URL.revokeObjectURL(link.href);
        this.$Message.success('导出成功');
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    // 获取过期提示文本
    getExpireText (expireTime) {
      if (this.$common.isEmpty(expireTime) || this.$common.isEmpty(new Date(expireTime))) return '-';
      // const diff = new Date(this.$common.toLocaleDate(expireTime)) - new Date();
      const diff = new Date(expireTime) - new Date();
      if (diff <= 0) return '已失效';
      const days = Math.floor(diff / (24 * 60 * 60 * 1000));
      const hours = Math.floor((diff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
      return `剩余 ${days}天${hours}时`;
    },
    // 预览图片
    previewImage (url) {
      if (!url) return;
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped lang="less">
.temp-image-bed-modal {

  :deep(.ivu-modal) {
    width: 80% !important;
    max-height: 1200px;
    top: 50px;
  }
  :deep(.ivu-modal-body) {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }
}
.temp-image-bed-content {
  .temp-image-bed-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e8eaec;

    .header-left {
      display: flex;
      align-items: center;
      gap: 10px;

      .header-icon {
        font-size: 28px;
        color: #2d8cf0;
      }

      .header-info {
        .header-title {
          font-size: 16px;
          font-weight: bold;
          color: #333;
        }

        .header-tip {
          font-size: 12px;
          color: #999;
          margin-top: 4px;

          .highlight {
            color: #ff9900;
          }
        }
      }
    }

    .header-right {
      text-align: right;
      font-size: 12px;
      color: #999;
    }
  }

  .upload-area-wrap {
    margin-bottom: 20px;

    .upload-drag-area {
      padding: 20px 0;
      text-align: center;

      .upload-main-text {
        margin-top: 12px;
        font-size: 14px;
        color: #666;

        .highlight-link {
          color: #2d8cf0;
          cursor: pointer;
        }
      }

      .upload-sub-text {
        margin-top: 8px;
        font-size: 12px;
        color: #999;
      }
    }
  }

  .table-area {
    .table-tabs-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      :deep(.ivu-tabs) {
        flex: 1;
      }

      .table-actions {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
      }
    }

    .table-page-wrap {
      text-align: right;
      margin-top: 10px;
    }
  }
}
</style>
